import React from 'react';
import { Route, Routes } from 'react-router-dom';
import BaseCreate from './Base/Create';
import BaseList from './Base/List';
import BaseEdit from './Base/Edit';
import List from './Inventory/List';
import Create from './Inventory/Create';
import './index.css';
import ErrorPage from '../Shared/ErrorPage';

const Inventory = () => {
  return (
    <div className="inventory">
      <Routes>
        {/* Base Inventory */}
        <Route path="*" element={<ErrorPage />} />
        <Route exact path={`/base/create`} element={<BaseCreate />} />
        <Route exact path={`/base/list`} element={<BaseList />} />
        <Route exact path={`/base/edit/:baseInventoryId`} element={<BaseCreate />} />
        {/* <Route exact path={`/base/edit/:baseInventoryId`} element={<BaseEdit />} /> */}
        {/* Inventory */}
        <Route exact path={`/list`} element={<List />} />
        <Route exact path={`/create`} element={<Create />} />
        <Route exact path={`/edit/:inventoryId`} element={<Create />} />
      </Routes>
    </div>
  );
}

export default Inventory 
